module.exports = __webpack_public_path__ + "img/sass-thumb-3.3ea2385d.png";